import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface PageErrorStateProps {
  /** Main error heading */
  title?: string;
  /** Description or error message */
  message?: string;
  /** Show a retry button */
  onRetry?: () => void;
  /** Height class for the container */
  className?: string;
}

/**
 * Standardised full-page error state.
 * Drop this into any page's error branch for a consistent look.
 */
export function PageErrorState({
  title = 'Something went wrong',
  message = 'We couldn\u2019t load this page. Please try again.',
  onRetry,
  className,
}: PageErrorStateProps) {
  return (
    <div role="alert" className={cn('flex flex-col items-center justify-center py-24 text-center', className)}>
      <AlertCircle aria-hidden="true" className="h-8 w-8 text-destructive mb-3" />
      <h3 className="text-sm font-medium text-foreground">{title}</h3>
      <p className="mt-1 text-sm text-muted-foreground max-w-sm">{message}</p>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} className="mt-4">
          Try Again
        </Button>
      )}
    </div>
  );
}
